module.exports = __webpack_public_path__ + "static/founders-at-work-c9fbf1dba1a32f80b1ed2d111640af04.jpg";